module.exports = __webpack_public_path__ + "media/images/plus-9e5fd29dd2275069f0cb712b4f5f1c9b.svg";